module.exports = __webpack_public_path__ + "static/media/winter_super_pack_dog_FR.0fadaa80.png";